export default defineNuxtPlugin((nuxtApp) => {
  const { setupUserLanguage, refreshUiTranslations } = useLanguageSetup()
  nuxtApp.hooks.hook('page:finish', async () => {
    await setupUserLanguage()
  })

  const refresh = () => {
    if (document.visibilityState === 'visible') {
      void refreshUiTranslations().catch(() => {
        // Keep current messages offline; the next trigger retries.
      })
    }
  }
  // Freshness uses wall-clock time in the loader, so suspended tabs catch up
  // immediately on return even if the browser never ran their interval.
  const timer = window.setInterval(refresh, 60 * 1000)
  document.addEventListener('visibilitychange', refresh)
  window.addEventListener('focus', refresh)
  window.addEventListener('pageshow', refresh)
  window.addEventListener('online', refresh)

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', refresh)
      window.removeEventListener('focus', refresh)
      window.removeEventListener('pageshow', refresh)
      window.removeEventListener('online', refresh)
    })
  }
})
